
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { Modal, message } from "ant-design-vue";
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "UserManageList",
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const router = useRouter();
    const dataSource = ref();
    const keyWord = ref("");
    const user_id = ref();
    const pagination = ref({
      page: 1,
      size: 10,
      total: 0,
    });
    const getListData = () => {
      const params = {
        page: pagination.value.page,
        size: pagination.value.size,
        keyword: keyWord.value,
      };
      Api.userManageList(params).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          pagination.value.total = Number(res.total_num) * 1;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const search = () => {
      pagination.value.page = 1;
      getListData();
    };
    const userDelF = () => {
      const param = {
        id: user_id.value,
      };
      Api.userDel(param).then((val) => {
        console.log(val);
        if (val.err_no == ResultCodeType.success_200) {
          message.success(t("successfullydeleted"));
          getListData();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const showDialogVisible = (item: any) => {
      console.log(item);
      if (item?.role_name != t("administrator")) {
        user_id.value = item.id;
        Modal.confirm({
          title: t("deleteconfirmation"),
          centered: true,
          content: t("deletedata"),
          okText: t("determine"),
          okType: "danger",
          onOk() {
            userDelF();
          },
        });
      } else {
        message.warning(t("admincannotbedeleted"));
      }
    };
    const addUserF = () => {
      router.push({ path: routerName.adduser });
    };
    const userEdit = (id: string) => {
      router.push({ path: routerName.adduser, query: { id: id, isEdit: 1 } });
    };
    const checkedId = ref("");
    const checkItem = (value: string) => {
      checkedId.value = value;
    };
    onMounted(() => {
      getListData();
    });

    return {
      checkItem,
      checkedId,
      pagination,
      columns: [
        {
          title: t("serialnumber"),
          dataIndex: "index",
          key: "index",
          align: "center",
        },
        {
          title: t("username"),
          dataIndex: "username",
          key: "username",
          align: "center",
        },
        {
          title: t("tel"),
          dataIndex: "mobile",
          key: "mobile",
          align: "center",
        },
        {
          title: t("role"),
          dataIndex: "role_name",
          key: "role_name",
          align: "center",
        },
        {
          title: t("lastlogintime"),
          dataIndex: "login_time",
          key: "login_time",
          align: "center",
        },
        {
          title: t("operate"),
          dataIndex: "car_model",
          key: "car_model",
          align: "center",
        },
      ],
      keyWord,
      dataSource,
      getListData,
      addUserF,
      userEdit,
      showDialogVisible,
      search,
      maxHeight,
      t,
    };
  },
});
